import { ArrowRight, Check, CreditCard, RotateCcw } from "lucide-react";
import Reveal from "@/components/Reveal";

const PassesSection = ({ onClassPass }) => (
  <section id="passes" className="passes-section section-space" aria-labelledby="passes-title">
    <Reveal className="section-inner passes-inner">
      <div className="passes-intro">
        <div className="section-kicker">LEARNING CLUB</div>
        <h2 id="passes-title">Show up. Save more.</h2>
        <p>Build a practice habit with a reward that makes every attended lesson count.</p>
        <a href="#contact-section" className="button button-crimson passes-intro-cta" onClick={(event) => { event.preventDefault(); onClassPass(); }} data-testid="passes-class-pass-cta">
          Claim Class Pass <ArrowRight size={16} />
        </a>
      </div>
      <article className="passes-card" data-testid="class-pass-info-card">
        <div className="passes-card-topline"><span>ATTENDANCE REWARD PROGRAM</span><span>01</span></div>
        <h3>Earn $20 Back Per Class</h3>
        <p className="passes-card-lead">Get $20 refunded directly to your card after every attended class.</p>
        <div className="passes-reward-row"><strong>$20</strong><span>back after you show up</span></div>
        <div className="passes-benefits">
          <div><CreditCard size={18} /><span>Applies to standard $32 Group and $55 Private sessions</span></div>
          <div><RotateCcw size={18} /><span>Up to 5 classes per month, 60 classes per year</span></div>
          <div><Check size={18} /><span>Not applicable to the 9-Class Private Pass Bundle</span></div>
        </div>
        <button className="button button-dark passes-card-cta" type="button" onClick={onClassPass} data-testid="passes-card-inquiry-button">
          Ask About the Reward <ArrowRight size={16} />
        </button>
      </article>
    </Reveal>
  </section>
);

export default PassesSection;
